import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { GenericCrudAddComponent } from 'src/app/libs/components/generic-crud/generic-crud-add.component';
import {Checkpoint, ECheckpointDataType} from 'src/app/models';
import { checkpointDataTypeSelectItems } from '../checkpoint-data-type-items';

@Component({
  selector: 'app-checkpoints-add',
  templateUrl: './checkpoints-add.component.html',
  styleUrl: './checkpoints-add.component.sass',
  standalone: false,
})
export class CheckpointsAddComponent extends GenericCrudAddComponent<Checkpoint> {
  override resource = this.api.resources.checkpoints;

  readonly dataTypes = checkpointDataTypeSelectItems(this.tr);
  ECheckpointDataType = ECheckpointDataType;
  sensors = this.api.resources.sensorTypes;

  override initFormGroup(): FormGroup {
    return this.fb.group({
      name: [],
      dataTypeId: [null],
      values: [null as string[] | null],
    });
  }

  protected override async mapFormEntity(): Promise<Partial<Checkpoint>> {
    const v = this.form!.value as Record<string, unknown>;
    let values = v['values'];
    if (values != null && !Array.isArray(values)) {
      values = [values];
    }
    const arr = Array.isArray(values)
      ? (values as unknown[]).filter(x => x != null && x !== '').map(x => String(x))
      : [];
    return {
      name: String(v['name'] ?? ''),
      companyId: this.api.auth.userValue!.lastCompanyId,
      dataTypeId: Number(v['dataTypeId'] ?? 0) as Checkpoint['dataTypeId'],
      values: arr.length > 0 ? arr : null,
    };
  }
}
